"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataGridRow = void 0;
var React = __importStar(require("react"));
var __1 = require("../");
var resize_observer_1 = require("@juggle/resize-observer");
var ResizeObserver = global.ResizeObserver || resize_observer_1.ResizeObserver;
var SELECTION_COL_ID = "gk-selection";
var EXPANSION_COL_ID = "gk-expansion";
var GKDataGridRow = function (props) {
    var _a;
    var isSelected = props.isSelected, isExpanded = props.isExpanded, row = props.row, qaProp = props.qaProp, rowDetail = props.rowDetail, onClick = props.onClick, prepareRow = props.prepareRow, rowProps = props.rowProps, limitedInstance = props.limitedInstance, virtualIndex = props.virtualIndex, style = props.style;
    prepareRow(row);
    var customProps = rowProps === null || rowProps === void 0 ? void 0 : rowProps(row, limitedInstance);
    var rowRef = React.useRef(null);
    var gridCtx = React.useContext(__1.GKDataGridContext);
    // Update the row height in the grid context.
    var updateRowHeight = React.useCallback(function (virtualRowIndex) {
        var _a;
        var height = Array.from(((_a = rowRef === null || rowRef === void 0 ? void 0 : rowRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(".tr")) || []).reduce(function (prev, current) { return prev + current.clientHeight; }, 0);
        if (gridCtx.getRowHeight(virtualRowIndex) !== height)
            gridCtx.setRowHeight(virtualRowIndex, height);
    }, [gridCtx, rowRef]);
    // Create a resize observer to watch for changes in the row height.
    var resizeObserver = React.useMemo(function () {
        return new ResizeObserver(function () {
            if (virtualIndex !== undefined)
                updateRowHeight(virtualIndex);
        });
    }, [updateRowHeight, virtualIndex]);
    // Observe the rows for changes in height when working with virtualized table.
    React.useEffect(function () {
        var _a, _b;
        var trElements;
        if (virtualIndex !== undefined) {
            trElements = ((_b = (_a = rowRef === null || rowRef === void 0 ? void 0 : rowRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(".tr")) !== null && _b !== void 0 ? _b : []);
            Array.from(trElements).forEach(function (el) { return resizeObserver.observe(el); });
        }
        return function () {
            if (virtualIndex !== undefined && (trElements === null || trElements === void 0 ? void 0 : trElements.length) > 0) {
                Array.from(trElements).forEach(function (el) { return resizeObserver.unobserve(el); });
            }
        };
    }, [resizeObserver, rowRef, virtualIndex]);
    var isCellClickable = function (colId) {
        return onClick ? colId !== SELECTION_COL_ID && colId !== EXPANSION_COL_ID : false;
    };
    return (React.createElement("div", { "data-qa": qaProp + "--tr-group", className: "tr-group", role: "rowgroup", ref: rowRef, style: style },
        React.createElement("div", __assign({ "data-qa": (_a = customProps === null || customProps === void 0 ? void 0 : customProps["data-qa"]) !== null && _a !== void 0 ? _a : qaProp + "--tr", className: [
                "tr",
                isSelected && "active",
                isExpanded && "expanded",
                customProps === null || customProps === void 0 ? void 0 : customProps.className,
            ]
                .filter(function (c) { return c; })
                .join(" "), id: customProps === null || customProps === void 0 ? void 0 : customProps.id }, row.getRowProps()), row.cells.map(function (cell) { return (
        // eslint-disable-next-line react/jsx-key
        React.createElement("div", __assign({ "data-qa": qaProp + "--td", className: "td col-" + cell.column.id + (isCellClickable(cell.column.id) ? " has-onclick" : ""), onClick: isCellClickable(cell.column.id) ? function () { return onClick === null || onClick === void 0 ? void 0 : onClick(row); } : undefined, onKeyDown: function () { return false; } }, cell.getCellProps(), { role: onClick ? "button" : "cell" }), cell.render("Cell"))); })),
        row.isExpanded && (React.createElement("div", { "data-qa": qaProp + "--tr-subcomponent", className: "tr tr-subcomponent" },
            React.createElement("div", { "data-qa": qaProp + "--td-subcomponent", className: "td td-subcomponent", id: "row-" + row.id + "-subcomponent", "aria-labelledby": "row-" + row.id + "-expander" }, rowDetail === null || rowDetail === void 0 ? void 0 : rowDetail(row))))));
};
exports.GKDataGridRow = GKDataGridRow;
/** A single, memoized data grid row */
// export const GKDataGridRow = React.memo(GKDataGridRowMemo, (prev, current) => {
//   return (
//     prev.isExpanded === current.isExpanded &&
//     prev.isSelected === current.isSelected &&
//     prev.isTableResizing === current.isTableResizing &&
//     prev.row.cells.length === current.row.cells.length &&
//     prev.virtualIndex === current.virtualIndex &&
//     prev.style === current.style &&
//     isEqual(
//       prev.rowProps?.(prev.row, prev.limitedInstance),
//       current.rowProps?.(current.row, current.limitedInstance)
//     ) &&
//     isEqual(prev.original, current.original)
//   );
// });
